/**
 * UploadedDocRow — a single row in the "previously uploaded" list.
 * Shows the document label and an optional download button.
 */
import { FileText, Download, Loader2 } from 'lucide-react';
import { getDocLabel } from '../utils/format-utils';
import { PALETTE_FOREST } from '../tokens';

interface UploadedDoc {
  id:              string;
  document_type:   string;
  document_label?: string | null;
  is_downloadable: boolean;
}

interface UploadedDocRowProps {
  doc:              UploadedDoc;
  isDownloading:    boolean;
  onDownload:       (documentId: string) => void;
}

export function UploadedDocRow({ doc, isDownloading, onDownload }: UploadedDocRowProps) {
  return (
    <div className="flex items-center gap-2 rounded-lg border border-border px-2.5 py-2">
      <FileText className="h-3.5 w-3.5 text-muted-foreground shrink-0" />
      <span className="text-xs text-foreground truncate flex-1">
        {doc.document_label ?? getDocLabel(doc.document_type)}
      </span>
      {doc.is_downloadable && (
        <button
          type="button"
          onClick={() => onDownload(doc.id)}
          disabled={isDownloading}
          className="shrink-0 h-6 w-6 rounded flex items-center justify-center transition-colors disabled:opacity-40 hover:opacity-70"
          style={{ color: PALETTE_FOREST }}
          title="Download"
        >
          {isDownloading
            ? <Loader2 className="h-3.5 w-3.5 animate-spin" />
            : <Download className="h-3.5 w-3.5" />
          }
        </button>
      )}
    </div>
  );
}
